import AssetSvc from '@/services/AssetSvc';

export default async function getScopedAssets() {
  const res = await AssetSvc.getAssets({ params: { page: 1, max: 1000 } });
  return res.data?.data || [];
}
